import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Ink from 'react-ink';

import ListingComponent from './ListingsComponent';
import './Style';

class ListingsContainer extends Component {
    constructor(props) {
      super(props)

      this.state = {
         error: null,
         errorInfo: null
      };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        });
    }

    render () {
        const { listingsList, agentId, imageSizeParams } = this.props;
        const { error } = this.state;

        if (!listingsList.length || error) {
            return null;
        }

        // show 4 first blocks only
        const listingsBlocks = listingsList.slice(0, 4).map((listing, i) => {
            return <ListingComponent key={i} listingData={listing} imageSizeParams={imageSizeParams}/>
        });

        const viewAllBlock = listingsList.length > 4
            ? (
                <div className="show-all-btn">
                    <a
                        href={`/story/featured/${agentId}`}
                        target='_blank'
                        className="btn">
                        View all other listings
                        <Ink />
                    </a>
                </div>
            )
            : null;

        return (
            <div id="otherListings" className="listing-container">
                <h2 className="section-header">My other listings</h2>
                <div className="listings-list">
                    {listingsBlocks}
                </div>
                {viewAllBlock}
            </div>
        )
    }
}

ListingsContainer.propTypes = {
    listingsList: PropTypes.array.isRequired,
    agentId: PropTypes.number.isRequired
}

const mapStateToProps = (state) => {
    return {
        listingsList: state.listings.listingsList,
        agentId: state.agent.agentInfo.id,
        imageSizeParams: state.gallery.imageSizeParams,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListingsContainer)
